import { loadLevel } from './data/load';
import { defaultLevel } from './data/vanilla';
import './index.css';
import { setBasicScene } from './stores/basicSceneStore';
import { BasicScene } from './three/basicScene';
import { ItemPanel } from './ui/ItemPanel';
import { LevelPanel } from './ui/LevelPanel';
import { SelectionPanel } from './ui/SelectionPanel';
import { SettingsPanel } from './ui/SettingsPanel';
import { ToolPanel } from './ui/ToolPanel';
import { useEffect, useRef } from 'react';

export function App() {
  const mountRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const mount = mountRef.current;
    if (!mount) {
      return;
    }

    const scene = new BasicScene(mount);
    setBasicScene(scene);

    loadLevel(defaultLevel);

    return () => {
      setBasicScene(null);
      scene.dispose();
    };
  }, []);

  return (
    <div className="relative h-screen w-screen overflow-hidden">
      <div ref={mountRef} className="scene-canvas" />
      <div className="pointer-events-none absolute top-4 bottom-4 left-4 z-10 flex flex-col items-start gap-2">
        <LevelPanel />
        <SelectionPanel />
      </div>
      <div className="pointer-events-none absolute top-4 right-4 z-10 flex flex-col items-end gap-2">
        <ToolPanel />
        <ItemPanel />
      </div>
      <SettingsPanel />
    </div>
  );
}

export default App;
